import React from "react";
import PracticsQuestionTopics from "../../topics/PracticsQuestionTopics";


function ChapterWisePYQPhysTopics() {



  return (
    <>

      <PracticsQuestionTopics subject="physics" type="chapterwisepyq" />

    </>
  );
}

export default ChapterWisePYQPhysTopics;